import * as React from 'react';

import LegalFolder56 from './LegalFolder56';

export const legalFolder56 = () => <LegalFolder56 />;

export default {
    title: 'Illustration/LegalFolder56',
    component: LegalFolder56,
    parameters: {
        notes: "`import LegalFolder56 from 'box-ui-elements/es/illustration/LegalFolder56';`",
    },
};
